import * as Yup from 'yup';

const locationValidation = (t: (key: string) => string) => ({
  edit: Yup.object().shape({
    name: Yup.string().required(t('enterName')),
    province_id: Yup.string().required(t('select_province_id')),
    ward_id: Yup.string().required(t('select_ward_id')),
    location_type: Yup.string().required(t('select_type_location')),
    type: Yup.string().required(t('select_type')),
    radius: Yup.number()
      .typeError(t('radiusMustNumber'))
      .when('type', {
        is: 'circle',
        then: (schema) => schema.required(t('radius_value')).positive(t('radiusMustNumber')),
        otherwise: (schema) => schema.notRequired(),
      }),
    points: Yup.array()
      .of(
        Yup.object().shape({
          lat: Yup.number().required(),
          lng: Yup.number().required(),
        })
      )
      .min(1, t('pointRequired'))
      .required(t('pointRequired')),
  }),
});

export default locationValidation;
